import React from "react";
import { useCurrentAppVersion } from "../hooks/useCurrentAppVersion";

/**
 * Render current app version.
 * @returns
 */
export function CurrentAppVersion() {
	const { buildDate } = useCurrentAppVersion();
	return <div>{buildDate ? `v${buildDate}` : "..."}</div>;
}
